var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeFilledIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09885 1.87792C9.24907 1.61503 9.54262 1.46826 9.843 1.50581L10.1833 1.54835C12.0337 1.77964 13.227 3.62515 12.6786 5.40745L12.2655 6.74999H12.8041C14.7823 6.74999 16.219 8.63092 15.6985 10.5394L14.6758 14.2894C14.3198 15.5945 13.1343 16.5 11.7814 16.5H4.5C3.25736 16.5 2.25 15.4926 2.25 14.25V9C2.25 7.75732 3.25736 6.74999 4.5 6.74999H6C6.19464 6.74999 6.37436 6.6457 6.47093 6.47671L9.09885 1.87792ZM5.25 8.25V14.25C5.25 14.513 5.29511 14.7654 5.37803 15H4.5C4.08579 15 3.75 14.6642 3.75 14.25V9C3.75 8.58577 4.08579 8.25 4.5 8.25H5.25Z",
    fill: "currentFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFilledIcon);
export default __webpack_public_path__ + "static/media/LikeFilledIcon.f0b8a7a481a09a8182fc90cc8ed93bc2.svg";
export { ForwardRef as ReactComponent };